import React from 'react'
import { getBEMCls } from '@/utils/classname'
import { Expaned } from '@/components/layout/layout'
import Button from '@/components/button/button'

import './staff-list.scss'
import StaffListTable from './staff-list-table/staff-list-table'
import { observer } from 'mobx-react'
import { shopStore } from '@/store/shop'
import { staffListModel } from './model'
import Auth from '@/views/main/components/auth/auth'
import { openStaffEntry } from '../staff-entry'

const StaffList = observer(() => {
    const getCls = (e?: string, m?: string) => getBEMCls('staff-list', e, m)

    return (
        <>
            <Expaned className={getCls()}>
                <div className={getCls('header')}>
                    <Auth
                        perssion={21}
                        onClick={() => {
                            openStaffEntry({
                                currentVersion: shopStore.currentVersion,
                                staffNum: staffListModel.staffNum,
                                maxStaffNum: staffListModel.maxStaffNum,
                            })
                        }}
                    >
                        <Button types="default">添加员工</Button>
                    </Auth>
                </div>
                <Expaned data-row className={getCls('content')}>
                    <StaffListTable />
                </Expaned>
            </Expaned>
        </>
    )
})

export default StaffList
